import React from "react";
import { Space, Spin } from "antd";
const Fallback = () => (
  <Space
  className="space-loading-container"
  // direction="vertical"

  // style={{
  //     width: '100%',
  //     height: '100%'
  // }}
  >
    <Spin fullscreen tip="Loading..." />
  </Space>
  
);
export default Fallback;
